<template>
    <section id="FAQ" class="section contact-main">
        <div class="container text-center">
            <div class="row items-gap align-items-center">
                <div class="col-12 col-lg-6 col-xxl-5">
                    <div class="contact-main__content wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <h2 class="h3">
                            {{ labelsState['need_help'] || '¿Need help?' }}
                            <span>{{ labelsState['contact_us'] || 'Contact Us.' }}</span>
                        </h2>
                        <p>
                            {{ labelsState['contact_description'] || 'Do not hesitate, talk to one of our advisors, we will help you with any concerns whenever you need it.' }}
                        </p>
                        <div class="arrow">
                            <img :src="require('@/assets/images/arrow-contact.png')" alt="Image">
                        </div>
                        <div class="cta-contact">
                            <a href="https://wa.me/3185814142" target="_blank" rel="noopener noreferrer">
                                WhatsApp
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                            <span>{{ labelsState['or'] || 'O' }}</span>
                            <a href="mailto:contacto@nqartificial.com">
                                {{ labelsState['email'] || 'Email' }}
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                           
                            
                        </div>
                        
                        <div class="cta-contact twilio-container">
                            
                            <a>
                                
                                <TwilioCallButton 
                                    :config-id=twilioConfigId
                                    :api-host="apiHostUrl"
                                />
                            </a>
                            
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    </section>
</template>


<script>
import { ref, onMounted, computed, mounted } from 'vue';
import axios from 'axios';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';
import TwilioCallButton from './TwilioCallButton.vue';
export default {
    name: "Contact",
    components: {
        TwilioCallButton
    },
    setup() {
        const labelsStore = useLabelsStore();
        const languageStore = useLanguageStore();
        const sharebotChatUrl = ref('');
        const labelsState = computed(() => labelsStore.labels);
        const languageCodes = computed(() => languageStore.codes);

        return {
            labelsState,
            languageCodes,
            sharebotChatUrl,
            changeLanguage: (languageCode) => labelsStore.fetchAndSetLabels(languageCode),
        };
    },
    data() {
    return {
        apiHostUrl: process.env.VUE_APP_HOST_INTEGRATIONS,
        twilioConfigId: process.env.VUE_APP_TWILIO_CONFIG_ID,
    };
    }
};
</script>

<style scoped>
.section.contact-main {
    display: flex;
    justify-content: center; 
    align-items: center; 
    min-height: 100vh; 
    width: 100%; 
    padding: 20px;
}

.container {
    width: 100%;
    max-width: 1200px; 
    margin: 0 auto; 
}

.row {
    display: flex;
    justify-content: center;
    align-items: center; 
    width: 100%;
}

.contact-main__content {
    text-align: center; 
}

.chat-container {
    margin-top: 20px;
}

.chat-container iframe {
    border: none;
    border-radius: 10px;
}

.twilio-container {
  margin-top: 15px;
  margin-left: 35%;

}

@media (max-width: 768px) {
    .chat-container iframe {
        height: 400px;
    }
    .twilio-container {
        margin-top: 15px;
        margin-left: 0%;
    }
}

</style>